import React from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'


import './PrivacyModal.css'

function PrivacyModal(props) {
    

    





    return (
        <div  >
                <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Privacy Policies
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          <div>
              <p>
              <h5>Introduction</h5>
                This privacy policy has been compiled to better serve those who are concerned with how
                their ‘Personally Identifiable Information’ (PII) is being used online. PII, as used in privacy
                law and information security, is information that can be used on its own or with other
                information to identify, contact, or locate a single person, or to identify an individual in
                context. Please read our privacy policy carefully to get a clear understanding of how we
                collect, use, protect or otherwise handle your Personally Identifiable Information in
                accordance with our website.
              </p>
              <p>
                What personal information do we collect from the people that visit our blog, website or app?
              </p>
              <p>
                When booking or registering on our site, as appropriate, you may be asked to enter your
                name, email address, mailing address, phone number, credit card information or other
                details to help you with your experience.
              </p>
              <h5>When do we collect information?</h5>
              <p>
                We collect information from you when you register on our site, book an accommodation,
                subscribe to a newsletter, fill out a form or enter information on our site.
              </p>
              <h5>How do we use your information?</h5>
              <p>
                We may use the information we collect from you when you register, make a booking, sign
                up for our newsletter, respond to a survey or marketing communication, surf the website,
                or use certain other site features in the following ways:
              </p>
              <ul>
                <li>To allow us to better service you in responding to your customer service requests.</li>
                <li>To quickly process your transactions.</li>
                <li>To send periodic emails regarding your booking or other products and services.</li>
              </ul>
              <h5>How do we protect visitor information?</h5>
              <p>
                Our website is scanned on a regular basis for security holes and known vulnerabilities in
                order to make your visit to our site as safe as possible.
              </p>
              <h5>We use regular Malware Scanning.</h5>
              <p>
                We do not use an SSL certificate because Credit Card details and transactions are handled by
                Razorpay, a third party, which has an SSL Certificate.
              </p>
              <h5>Do we use ‘cookies’?</h5>
              <p>
                We do not use cookies for tracking purposes. However, in case in future we decide to use
                cookies, you can choose to have your computer warn you each time a cookie is being sent,
                or you can choose to turn off all cookies. You do this through your browser (like Internet
                Explorer) settings. Each browser is a little different, so look at your browser’s Help menu to
                learn the correct way to modify your cookies.
              </p>
              <p>
                In future, if we introduce cookies and you disable cookies off, some features of the website
                will be disabled that make your site experience more efficient and some of our services will
                not function properly.
              </p>
              <p>
                However, you can still surf our website and make bookings.
              </p>
              <h5>Third Party Disclosure</h5>
              <p>
                We do not sell, trade, or otherwise transfer to outside parties your personally identifiable
                information unless we provide you with advance notice. This does not include website
                hosting partners and other parties who assist us in operating our website, conducting our
                business, or servicing you, so long as those parties agree to keep this information
                confidential. We may also release your information when we believe release is appropriate
                to comply with the law, enforce our site policies, or protect ours or others’ rights, property,
                or safety.
              </p>
              <p>
                However, non-personally identifiable visitor information may be provided to other parties
                for marketing, advertising, or other uses.
              </p>
              <h5>Third party links</h5>
              <p>
                Occasionally, at our discretion, we may include or offer third party products or services on
                our website. These third party sites have separate and independent privacy policies. We
                therefore have no responsibility or liability for the content and activities of these linked
                sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback
                about these sites.
              </p>
              <h5>Users can visit our site anonymously.</h5>
              <p>Once this privacy policy is created, we will add a link to it on our home page, or as a
                  minimum on the first significant page after entering our website.
              </p>
              <p>
                Our Privacy Policy link includes the word ‘Privacy’, and can be easily be found on the page
                specified above.
              </p>
              <p>
                Users will be notified of any privacy policy changes: On our Privacy Policy Page
              </p>
              <p>
                Users are able to change their personal information: By logging in to their account
              </p>
              <p>
                How does our site handle do not track signals?
              </p>
              <ul>
                <li>
                    We honour do not track signals and do not track, plant cookies, or use advertising
                    when a Do Not Track (DNT) browser mechanism is in place.
                </li>
              </ul>
              <p>Does our site allow third party behavioural tracking?</p>
              <ul>
                <li>
                  It’s also important to note that we do not allow third party behavioural tracking.
                </li>
              </ul>
              <h5>COPPA (Children Online Privacy Protection Act)</h5>
              <p>
                When it comes to the collection of personal information from children under 13, the
                Children’s Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade
                Commission, the USA’s consumer protection agency, enforces the COPPA Rule, which spells
                out what operators of websites and online services must do to protect children’s privacy
                and safety online.
              </p>
              <p>
                We do not specifically market to children under 13.
              </p>
              <h5>Fair Information Practices</h5>
              <p>
                The Fair Information Practices Principles form the backbone of privacy law in the United
                States and the concepts they include have played a significant role in the development of
                data protection laws around the globe. Understanding the Fair Information Practice
                Principles and how they should be implemented is critical to comply with the various privacy
                laws that protect personal information.
              </p>
              <p>
                In order to be in line with Fair Information Practices we will take the following responsive
                action, should a data breach occur:
              </p>
              <ul>
                <li>We will notify the users via email</li>
                <li>Within 3 business days</li>
                <li>We will notify the users via in site notification</li>
                <li>Within 1 business day</li>
              </ul>
              <p>
                We also agree to the individual redress principle, which requires that individuals have a right
                to pursue legally enforceable rights against data collectors and processors who fail to
                adhere to the law. This principle requires not only those individuals have enforceable rights
                against data users, but also that individuals have recourse to courts or a government agency
                to investigate and/or prosecute non-compliance by data processors.
              </p>
              <h5>CAN SPAM Act</h5>
              <p>
                The CAN-SPAM Act is a law that sets the rules for commercial email, establishes
                requirements for commercial messages, gives recipients the right to have emails stopped
                from being sent to them, and spells out tough penalties for violations.
              </p>
              <p>
                We collect your email address in order to:
              </p>
              <ul>
                <li>Send periodical news-letters and enable email based login.</li>
                
              </ul>
              <p>
                  To be in accordance with CANSPAM we agree to the following:
              </p>
              <ul>
                <li>
                    If at any time you would like to unsubscribe from receiving future emails, you can
                    email us at unsubscribe@saishreyasresidency.com and we will promptly remove you
                    from ALL correspondence.
                </li>
              </ul>
              <h5>Contacting Us</h5>
              <p>
                If there are any questions regarding this privacy policy you may contact us using the
                information below:
              </p>
              <h5>Sai Shreyas Residency</h5>
              <p>
                <a className='lien' href="www.saishreyasresidency.com">www.saishreyasresidency.com</a>
              </p>
              <p>
                <a className='lien' href='https://www.google.co.in/maps/place/Sai+Shreyas+Residency/@13.1669069,77.6298555,17z/data=!3m1!4b1!4m8!3m7!1s0x3bae1fec3733bf8b:0x54635ac4c5593d37!5m2!4m1!1i2!8m2!3d13.1669074!4d77.6320434'>Map Link</a>
              </p>
              <p>
                  #371/11, Kadiganahalli Gate, Kempegowda International Airport Road, Near Decathlon
                  Anubhava, Chikkajala, Bengaluru, Karnataka 562157
              </p>
              <p >
                Email: <span style={{borderBottom:'solid 1px'}}>info@saishreyasresidency.com</span>
              </p>
              



          </div>
          
          
          
        </Modal.Body>
        <Modal.Footer>
          <Button className='closeBtn' onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
        </div>
      
    );
  }





export default PrivacyModal

